<template>
  <div>
    <Table
      resource="Voucher"
      :actions="actions"
      :items="$store.getters['voucher/tableData']"
      :detail="$store.getters['voucher/detailData']"
      :fields="$store.getters['voucher/tableFields']"
      :pagination="$store.state.voucher.tablePagination"
      :keyword="$store.state.voucher.tableKeyword"
      :loading="$store.state.voucher.loadingTable"
      :filter="$store.state.voucher.tableFilter"
      :sort="$store.state.voucher.tableSort"
      :sort-options="sortOptions"
      @changeFields="changeFields"
      @resetFields="resetFields"
      @filter="filterData"
      @sort="sortData"
      @load="loadData"
      @delete="deleteData"
      @loadDetail="loadDetail"
      @resetDetail="resetDetail"
      @paginate="paginate"
      @search="search"
    />
  </div>
</template>

<script>
import Table from '@/layouts/components/Table.vue'

export default {
  components: {
    Table,
  },
  data() {
    return {
      // Sort
      sortOptions: [
        {
          key: 'created_at', direction: 'desc', label: 'Terbaru', default: true,
        },
        { key: 'created_at', direction: 'asc', label: 'Terlama' },
      ],

      actions: [
        'create',
        'view',
        'update',
        'delete',
      ],
    }
  },
  methods: {
    loadData() {
      return this.$store.dispatch('voucher/getTableData')
    },
    loadDetail(id) {
      return this.$store.dispatch('voucher/getDetail', id)
    },
    deleteData(id, callback) {
      return this.$store.dispatch('voucher/delete', id)
        .then(callback)
    },
    resetDetail() {
      this.$store.commit('voucher/SET_DETAIL_DATA', undefined)
    },
    changeFields(val) {
      this.$store.commit('voucher/SET_TABLE_FIELDS', val)
    },
    resetFields() {
      this.$store.commit('voucher/RESET_TABLE_FIELDS')
    },
    filterData(val) {
      this.$store.commit('voucher/SET_TABLE_FILTER', val)
    },
    sortData(val) {
      this.$store.commit('voucher/SET_TABLE_SORT', val)
    },
    paginate(val) {
      this.$store.commit('voucher/SET_TABLE_PAGINATION', val)
    },
    search(val) {
      this.$store.commit('voucher/SET_TABLE_KEYWORD', val)
    },
  },
}
</script>
